<template>
  <div class="popup-wrapper" @click.self="_close">
    <!-- <form action=""> -->
    <div class="popup-action">
      <div class="button button-submit">
        <div role="button" class="btn" 
          :class="[!newNote.isInputDataValid && 'is-inactive', ga.noteSaveClass]"
          @click="newNote.clickSubmit"
        >保存
        </div>
      </div>
      <div class="button button-close">
        <button class="btn" @click="_close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">新規ノートを作成して保存</span>
        </div>
        <div class="popup-content">
          <div class="popup-content-hdg">
            <div class="popup-content-hdg-sup">
              <span class="small">使用ノート数</span>
              <span class="large"><span :class="[noteNum.createNote >= noteNum.maxNote && 'max']">{{noteNum.formatCreateNote}}</span> / {{noteNum.formatMaxNote}}</span>
              <span class="small">最大ノート数</span>
            </div>
          </div>
          <div class="popup-content-body">

            <div class="popup-content-body-item popup-content-body-item-01">
              <p class="hdg04 mb12">ノートのタイトル</p>
              <div class="formparts text">
                <input @keydown.enter.prevent type="text" placeholder="タイトルを入力" v-model="newNote.title">
                <p v-if="validate.title" class="error-message">{{validate.title}}</p>
              </div>
            </div>

            <div 
              v-show="state.isShareAreaShown"
              class="popup-content-body-item popup-content-body-item-02">
              <p class="hdg04 mb12">共有指定</p>
              <div class="formparts radio">
                <input type="radio" id="note_select_share_1"
                  :value="1"
                  v-model.number="newNote.share"
                  @change="share.onShareTypeChanged">
                <label for="note_select_share_1">プライベート</label>
              </div>
              <div class="formparts radio">
                <input type="radio" id="note_select_share_2" 
                  :value="2"
                  v-model.number="newNote.share"
                  @change="share.onShareTypeChanged">
                <label for="note_select_share_2">共有</label>
              </div>
              <p class="error-message" 
                v-if="newNote.share === 2 && !share.isUsersToShareSelected"
                >アカウントを指定してください。</p>
              <div 
                class="formparts-hidden"
                v-show="newNote.share === 2">
                <div class="formparts radio">
                  <input type="radio" id="note_share_classification_21"
                    :value="21"
                    v-model.number="newNote.share_classification"
                    @click="share.onShareClassificationClicked(21, true)"
                    :disabled="newNote.share !== 2">
                  <label for="note_share_classification_21">閲覧権限を付与する</label>
                  <a class="txt-blue" role="button"
                    v-if="newNote.share_classification === 21 && share.isUsersToShareSelected"
                    @click="share.onShareClassificationClicked(21, false)">閲覧・編集</a>
                </div>
                <div class="formparts radio">
                  <input type="radio" id="note_share_classification_22" 
                    :value="22"
                    v-model.number="newNote.share_classification"
                    @click="share.onShareClassificationClicked(22, true)"
                    :disabled="newNote.share !== 2">
                  <label for="note_share_classification_22">編集権限を付与する</label>
                  <a class="txt-blue" role="button"
                    v-if="newNote.share_classification === 22 && share.isUsersToShareSelected"
                    @click="share.onShareClassificationClicked(22, false)">閲覧・編集</a>
                </div>
              </div>
            </div>

            <div class="popup-content-body-item popup-content-body-item-03">
              <p class="hdg04">タグ</p>
              <div class="formparts function">
                <input @keydown.enter.prevent="newNote.clickAddTag" type="text" v-model="newNote.tagText" name="note_select_tag" placeholder="タグを追加">
                <div @click="newNote.clickAddTag" class="button" role="button"><span class="icn register">登録</span></div>
              </div>
              <div v-if="newNote.displayPastTags.length > 0" role="button" class="txt-blue mt12"
                @click="state.isOpenHistoryTags = !state.isOpenHistoryTags"
                :class="{'is-open' : state.isOpenHistoryTags}"
              >
                登録済のタグから追加
                <FontawesomeIcon icon="angle-down" class="icn down" />
                <FontawesomeIcon icon="angle-up" class="icn up" />
              </div>
              <div class="tags-history mt8"
                v-if="state.isOpenHistoryTags && newNote.displayPastTags.length > 0"
              >
                <div  
                  v-for="tag in newNote.displayPastTags"
                  :key="'pastTags_' + tag.id"
                  @click="newNote.clickPastTag(tag.name)"
                  class="tag bottom"
                >
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">{{tag.name}}</span>
                  </div>
                </div>
              </div>
              <div v-if="newNote.tags.length > 0" class="mt8">
                <div
                  v-for="tag in newNote.tags"
                  :key="'Tags_' + tag"
                  @click="newNote.clickTag(tag)"
                  class="tag"
                >
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">{{tag}}</span>
                    <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="popup-content-body-item popup-content-body-item-04">
              <p class="hdg04 mb12">見出し</p>
              <div class="formparts text">
                <input @keydown.enter.prevent type="text" placeholder="見出しを入力" v-model="newNote.heading">
              </div>
            </div>

            <div class="popup-content-body-item popup-content-body-item-05">
              <p class="hdg04 mb12">コメント</p>
              <div class="formparts textarea">
                <textarea rows="5" placeholder="コメントを入力" v-model="newNote.comment"></textarea>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import { SelectNote } from '@/logic/common/SelectNote'

export default defineComponent({
  name: 'SPNoteCreate',
  props: {
    type: {
      type: String,
      default: ''
    },
    pageId: {
      type: Number,
      default: null
    },
    note_row_id: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    currentNoteId: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {
    const state = reactive({
      isOpenHistoryTags: false
    })
    const _close = () => {
      context.emit('closeCreateNote')
    }
   
    return {
      state,
      _close,
      ...SelectNote(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 20px 20px 20px 0!important;
  background-color: $color-bg-paper;
  &-hdg {
    padding: 0 0 20px 20px;
    &-sup {
      .small {
        vertical-align: middle;
        color: $color-sup;
        font-size: 1.2rem;
      }
      .large {
        margin: 0 10px;
        vertical-align: middle;
        font-size: 2.4rem;
        font-weight: bold;
        color: $color-content;
      }
    }
  }
  &-body {
    background-color: #fff;
    border-top: 1px solid $color-line;
    border-right: 1px solid $color-line;
    border-bottom: 1px solid $color-line;
    border-radius: 8px;
    .hdg04 {
      margin-bottom: 20px;
    }
    &-item {
      padding: 20px;
      border-bottom: 1px solid $color-line;
      &:last-child {
        border-bottom: 0;
      }
      &-02 {
        .error-message {
          margin: 8px 0 0;
          padding-left: 30px;
        }
        .formparts-hidden {
          margin-top: 16px;
          padding-left: 30px;
          .formparts.radio {
            label {
              display: inline-block;
              & + a {
                margin-left: 12px;
              }
            }
          }
        }
      }
      &-03 {
        .txt-blue {
          font-size: 1.4rem;
          @include hoverOpacity;
          .up {
            display: none;
          }
          &.is-open {
            .up {
              display: inline;
            }
            .down {
              display: none;
            }
          }
        }
        .tags-history {
          padding-bottom: 20px;
          border-bottom: 1px solid $color-line;
        }
      }
    }
  }
}

</style>
